import React from 'react';
import i18n from '../../i18n';
import {makeNewFromInterval} from '../../fn/datehelper';
import {withFormik} from 'formik';
import axios from 'axios';
import Button from "@material-ui/core/Button";
import Icon from "@material-ui/core/Icon";
import FormField from "../Form/FormField";
import FormDate from "../Form/FormDate";
import Grid from "@material-ui/core/Grid/Grid";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import {withStyles} from "@material-ui/core";
import {getPersonName, mergeWithDefault} from "../Form/utils";
import FormCheck from "../Form/FormCheck";
import swal from "sweetalert";
import FormAutocomplete from "../Form/FormAutocomplete";
import {array, object, string} from "yup";
import DeleteButton from "../Form/DeleteButton";
import FormSelect from "../Form/FormSelect";
import Divider from '@material-ui/core/Divider';
import MediaDropButton from '../Media/DropButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormNumber from "../Form/FormNumber";

class AppointmentFormFields extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showCompany: false,
        };
    }

    render() {
        const {
            values,
            touched,
            errors,
            customer,
            machines,
            technicians,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            formUrl,
            isEdit,
            setFormikState,
        } = this.props;

        return (
            <form
                method="POST"
                url={formUrl}
                onSubmit={handleSubmit}
            >

                <input type="hidden" name="customer_id" value={values.customer_id} onChange={handleChange}/>

                <Grid container spacing={24}>
                    <Grid container item xs={12} spacing={16}>
                        <Grid item xs={12} sm={6}>
                            <FormField
                                type="text"
                                disabled
                                autoComplete={false}
                                name="customer_name"
                                label={i18n.get('appointments.board_name')}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={customer.customer_name}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormField
                                type="text"
                                name="appointment_name"
                                label={i18n.get('appointments.appointment_name')}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.appointment_name}
                                error={errors.appointment_name}
                                touched={touched.appointment_name}
                            />
                        </Grid>
                    </Grid>
                    <Grid container item xs={12} spacing={16}>
                        <Grid item xs={12} sm={3}>
                            <FormField
                                type="number"
                                name="project_number"
                                label={i18n.get('appointments.project_number')}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.project_number}
                                error={errors.project_number}
                                touched={touched.project_number}
                            />
                        </Grid>
                        <Grid item xs={12} sm={9} />
                    </Grid>
                    <Grid container item xs={12} spacing={16}>
                        <Grid item xs={2}>
                            <FormDate
                                type="date"
                                name="day_last_appointment"
                                label={i18n.get('appointments.day_last_appointment')}
                                onChange={(e) => {
                                    try {
                                        setFieldValue(
                                            "day_next_appointment",
                                            makeNewFromInterval(e.target.value, values.interval)
                                        );

                                        setFieldValue(
                                            "day_last_appointment",
                                            e.target.value
                                        );
                                    } catch ( ex ) {
                                        console.log(ex);
                                    }
                                }}
                                onBlur={handleBlur}
                                value={values.day_last_appointment}
                                error={errors.day_last_appointment}
                                touched={touched.day_last_appointment}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <FormSelect
                                name="interval"
                                label={i18n.get('appointments.interval')}
                                error={errors.interval}
                                touched={touched.interval}
                                onChange={(selectedOption) => {
                                    setFieldValue(
                                        "interval",
                                        selectedOption.value
                                    );

                                    values.day_next_appointment = makeNewFromInterval(values.day_last_appointment, selectedOption.value);
                                }}
                                options={[
                                    {label: 'individuell', value: 0},
                                    {label: 'monatlich', value: 1},
                                    {label: 'vierteljährlich', value: 2},
                                    {label: 'halbjährlich', value: 3},
                                    {label: 'jährlich', value: 4},
                                ]}
                                onBlur={handleBlur}
                                value={values.interval}
                            />
                        </Grid>
                        <Grid item xs={1} />
                        <Grid item xs={2}>
                            <FormDate
                                type="date"
                                name="day_next_appointment"
                                label={i18n.get('appointments.day_next_appointment')}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.day_next_appointment}
                                error={errors.day_next_appointment}
                                touched={touched.day_next_appointment}
                            />
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <FormCheck
                                name="remember"
                                label={i18n.get('appointments.remember')}
                                error={errors.remember}
                                touched={touched.remember}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.remember}
                            />
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <FormNumber
                                type="text"
                                name="days_before_remember"
                                label={i18n.get('appointments.remember_days')}
                                // label_exclaim={this.state.url && (<a href={this.state.url}
                                //                                      target={"_blank"}>{i18n.get('utilitybill.form.show_utility_bill_values')}</a>)}
                                onChange={handleChange}
                                value={values.days_before_remember}
                                fixedDecimalScale={false}
                            />
                        </Grid>
                    </Grid>
                    <Grid container item xs={12} spacing={16}>
                        <Grid item xs={6} sm={3}>
                            <FormSelect
                                name="technician_id"
                                label={i18n.get('appointments.technician')}
                                error={errors.technician_id}
                                touched={touched.technician_id}
                                onChange={selectedOption =>
                                    setFieldValue(
                                        "technician_id",
                                        selectedOption.value
                                    )}
                                onBlur={handleBlur}
                                options={technicians.map((value) => ({
                                    label: value.name,
                                    value: value.id,
                                    entity: value
                                }))}
                                value={values.technician_id}
                            />
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <FormSelect
                                name="machine_id"
                                label={i18n.get('structures.machine')}
                                error={errors.machine_id}
                                touched={touched.machine_id}
                                onChange={selectedOption =>
                                    setFieldValue(
                                        "machine_id",
                                        selectedOption.value
                                    )}
                                onBlur={handleBlur}
                                options={machines.map((value) => ({label: value.name, value: value.id, entity: value}))}
                                value={values.machine_id}
                            />
                        </Grid>
                    </Grid>

                    <Grid item xs={12}>
                        <Divider/>
                    </Grid>
                </Grid>

                <Grid container spacing={24} justify="space-between" alignItems="center" style={{paddingTop: 8}}>
                    <Grid item>
                        {isEdit && (
                            <DeleteButton
                                href={`/appointments/${values.id}`}
                                confirmMessage={i18n.get('appointments.confirm_message')}
                                successMessage={i18n.get('appointments.delete_success_message')}
                                handleSuccess={() => {
                                    history.go(-2)
                                }}
                            />
                        )}
                    </Grid>
                    <Grid item>
                        <Button size="small"
                                variant="contained"
                                color="primary"
                                type="submit"
                        >
                            {isEdit ?
                                (<Icon fontSize="small">refresh</Icon>) :
                                (<Icon fontSize="small">save</Icon>)
                            } &nbsp;
                            {isEdit ? i18n.get('persons.update') : i18n.get('persons.save')}
                        </Button>
                    </Grid>
                </Grid>
            </form>
        )
    }
}

export default AppointmentFormFields



// WEBPACK FOOTER //
// ./resources/assets/js/components/Appointments/AppointmentFormFields.js